import React, { Fragment, useState } from 'react';
import Loader from '../Main/Loader';
import AppPagination from '../Main/Pagination';
import ShopCard from '../Main/ShopCard';
import useShopList from '../../Hooks/Shop/useShopList';


const ShopList = () => {

    const [
        filterRange,
        allProducts,
        isLoading,
        links,
        currentPage,
        totalProducts,
        showingProducts,
        handlecCurrentPage,
        handleRangeChange,
        allCategories,
        category,
        setCategory
    ] = useShopList();





    return (
        <Fragment>
            <div className="container mt-5 shop-list">
                <div className="row">
                    <div className="col-lg-4 mt-5">
                        <div className="card bg-dark  py-5">
                            <div className="bard-body px-4">
                                <h2 className='text-light  heading mb-4'>Categories</h2>

                                <ul>
                                    <li onClick={() => { setCategory("") }}
                                        className={`${category === "" ? "bg-white text-dark rounded-2 fw-600 ps-2" : "cursor-pointer"}`}
                                    >All</li>
                                    {Array?.isArray(allCategories) && allCategories?.length > 0 ? (
                                        allCategories?.map((item, i) => {
                                            return (
                                                <>
                                                    <li onClick={() => { setCategory(item?.id) }}
                                                        className={`${category === item?.id ? "bg-white text-dark rounded-2 fw-600 ps-2" : "cursor-pointer"}`}>{item?.name}</li>
                                                </>
                                            )
                                        })
                                    ) : ("No data found")}

                                </ul>
                            </div>

                            <hr className='text-light' />

                            <div className="p-4 card-body">
                                <h5 className='text-white fw-600'>Filter Price</h5>
                                <input
                                    type="range"
                                    className="form-range bg-transparent"
                                    min="0"
                                    max="100"
                                    value={filterRange}
                                    step="1"
                                    id="customRange3"
                                    onChange={handleRangeChange}
                                />
                                <div className="row">
                                    <div className="col">
                                        <p className='text-white mb-0'>
                                            $50
                                        </p>
                                    </div>
                                    <div className="col">
                                        <p className='text-white text-end mb-0'>
                                            ${filterRange}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <hr className='text-light' />

                            <div className="p-4 card-body">
                                <button className='w-100 s-16 fw-500 py-4 btn btn-danger'>
                                    Filter
                                </button>
                            </div>

                        </div>
                    </div>

                    <div className="col-lg-8 my-5">

                        {isLoading ? <Loader /> : (

                            <div className="row  g-3 ">
                                {Array.isArray(allProducts) && allProducts?.length > 0 ? (
                                    allProducts?.map((item, i) => {
                                        return (
                                            <div className="col-lg-3">
                                                <>
                                                    <ShopCard
                                                        key={i}
                                                        img={item?.image_url}
                                                        productTitle={item?.title}
                                                        price={item?.latest_price}
                                                        slug={item?.slug}
                                                        id={item?.id}
                                                    />
                                                </>
                                            </div>
                                        )
                                    })

                                ) : ("No data Found")}

                            </div>
                        )}

                        {
                            allProducts?.length > 0 && (
                                <div className="col-12">
                                    <AppPagination
                                        links={links}
                                        handlecCurrentPage={handlecCurrentPage}
                                        totalProducts={totalProducts}
                                        showingProducts={showingProducts}
                                    />
                                </div>
                            )
                        }

                    </div>



                </div>


            </div>
        </Fragment>
    )
}

export default ShopList